import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as style from './style.module.css';

const Error = ({ icon, message = '', code = '', disableMargin = false }) => (
  <div className={`${style.error} ${disableMargin ? style.noMargin : ''}`}>
    <FontAwesomeIcon className={style.icon} icon={icon} />
    <div className={style.message}>{message}</div>
    {code && <div className={style.code}>{code}</div>}
  </div>
);

export default Error;
